import { render, staticRenderFns } from "./RMAHeader.vue?vue&type=template&id=243dd0c8&scoped=true&"
import script from "./RMAHeader.vue?vue&type=script&lang=js&"
export * from "./RMAHeader.vue?vue&type=script&lang=js&"
import style0 from "./RMAHeader.vue?vue&type=style&index=0&id=243dd0c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243dd0c8",
  null
  
)

export default component.exports